<template>
  <div class="edcity-add-school">
    <v-row>
      <v-col class="m-5">
        <v-text-field
          v-model="form.school_code"
          :label="labelHeader('school_code')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.passcode"
          :label="labelHeader('passcode')"
          required
          type="password"
        ></v-text-field>
      </v-col>      
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="primary" @click="getSchoolTeachersBySchoolCode()">
          {{ $t("manage.by_edcity.list_school_teachers.btn.list_school_teachers") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-content>
            <v-data-table
              dense
              :headers="tableHeader()" 
              :items="api.edcity_teachers" 
              item-key="profile_id"
              :items-per-page="100">
              
            </v-data-table>
          </v-card-content>
        </v-card>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="exportToCsv">
      {{ $t("manage.by_edcity.list_school_teachers.btn.export_to_csv") }}
    </v-btn>

  </div>
</template>

<script>
import { api_edcity } from "@/services/dds/api_edcity";
const apiEdCity = new api_edcity(process.env.VUE_APP_BASE_URL);
export default {
  name: "CreateBookSlot",
  data: function () {
    return {
      current: {
        username: null,
        uid: null,
        user_level: null,
        auth_token: null,
      },
      form: {
        school_code: null,
        school_year: null,
        passcode: null,
      },
      api: {
        edcity_teachers: [],
      },
      teachers_header: [
        { text: 'School Code', value: 'school_code' },
        { text: 'EN Name', value: 'teacher_enname' },
        { text: 'CH Name', value: 'teacher_chname' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      teachers_header_chi: [
        { text: '學校代碼', value: 'school_code' },
        { text: '英文姓名', value: 'teacher_enname' },
        { text: '中文姓名', value: 'teacher_chname' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      selected_keys: [
        'hkedcity_id',
        'profile_id',
        'display_name',
        'school_code',
        'teacher_enname',
        'teacher_chname'
      ],
    };
  },
  mounted: function () {
    var self = this;
    //self.current.school_id = self.$route.params.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    tableHeader(label){
      var self = this;
      if(self.$i18n.locale=='tc') return self.teachers_header_chi;
      else return self.teachers_header;
    },
    labelHeader(label){
      var self = this;
      if(label=="school_code") return self.$t("manage.by_edcity.list_school_teachers.school_code");
      else if(label=="passcode") return self.$t("manage.by_edcity.list_school_teachers.passcode");
    },
    getSchoolTeachersBySchoolCode(){
      var self = this;
      
      apiEdCity.getSchoolTeachersBySchoolCode(self.form.school_code, self.form.passcode)
      .then((response) =>{
        if(response.status=="success"){
          self.api.edcity_teachers = response.result;
          self.$store.commit("showSnackBar", "Teachers are listed");
          
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.message);
        }
      });
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
    jsonToCsv(jsonArray) {
      var self = this;      
      if (!jsonArray.length) return '';

      const selectedKeys = self.selected_keys;

      const csvRows = [
        selectedKeys.join(','), // Header row
        ...jsonArray.map(obj =>
          selectedKeys.map(key => {
            const val = obj[key] !== undefined && obj[key] !== null ? obj[key] : '';
            return `"${String(val).replace(/"/g, '""')}"`;
          }).join(',')
        )
      ];

      return csvRows.join('\n');
    },
    downloadCsv(filename, csvContent) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportToCsv() {
      var self = this;      
      const jsonData = self.api.edcity_teachers; // Your JSON array
      if (!jsonData || jsonData.length === 0){
        self.$store.commit("showSnackBar", "No teachers are listed");
        return;
      }
      const csv = self.jsonToCsv(jsonData);
      self.downloadCsv('teachers'+ self.form.school_code +'.csv', csv);
    }


  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>